import React from "react";

const SectionWrapper = ({ id, children }) => {
    return (
        <section id={id} className="px-12 py-36 min-h-screen relative">
            {children}
        </section>
    );
}

export default SectionWrapper;